

































import { formatDate } from "@/lib/date";
import { Component, Mixins, Prop } from "vue-property-decorator";
import { mapGetters } from "vuex";
import AppApiMixin from "@/components/mixins/AppApi.vue";
import DocGetter from "@/components/mixins/DocGetter.vue";
import {AxiosResponse} from "axios";

@Component({
  computed: {
    ...mapGetters({
      contractId: "contract/id",
      currentAppealInfo: "appeals/getCurrentAppealInfo",
    })
  },
  filters: {
    formatDate(value: string): string {
      return formatDate(value, "fullWithTime");
    }
  }
})
class AppealChatMessage extends Mixins(AppApiMixin, DocGetter) {
  [x: string]: any;

  @Prop({ default: [] }) readonly item!: [];

  fileInfo: any;

  public get messageClass(): String {
    return 'pa-2 pl-4 pr-4 ' + (this.item['состояние'] ? 'chat-message-stack' : 'chat-message')
  }

  downloadAppealHistoryFile(fileId, text_info) {
    if (text_info.match(/^(Прикреплен\sфайл)/)) {
      this.getAppealFile({
        appealId: this.currentAppealInfo[0]['appealId'],
        fileId: fileId
      }).then((response: AxiosResponse) => {
          this.downloadDocument(response);
        })
        .catch((e) => console.log(e));
    }
  }
}
export default AppealChatMessage;
